import React from 'react';
import { Oval } from 'react-loader-spinner';
import './Loader.css';

/**
 * Themed full-screen or inline loader.
 * @param {string} [variant='light'] - 'light' (customer areas) or 'dark' (admin areas)
 * @param {string} [message] - Optional text below the spinner
 * @param {boolean} [fullScreen=true] - If true, fills viewport and centers; else inline block
 */
const Loader = ({ variant = 'light', message, fullScreen = true }) => {
  const isDark = variant === 'dark';
  const color = isDark ? '#98A1C0' : '#007bff';
  const wrapperClass = fullScreen ? 'loader-wrapper loader-fullscreen' : 'loader-wrapper loader-inline';

  return (
    <div className={`${wrapperClass} loader-variant-${variant}`}>
      <Oval
        visible
        height={48}
        width={48}
        color={color}
        ariaLabel="loading"
        strokeWidth={4}
      />
      {message && <p className="loader-message">{message}</p>}
    </div>
  );
};

export default Loader;
